<div class="uk-section uk-section-small stats">
  <div class="uk-container uk-container-expand">

    <h2>Resources Statistics</h2>

    <div class="uk-margin-medium-top">

      <!--LAPTOP & PAD LANDSCAPE-->
      <ul class="uk-visible@m uk-tab uk-tab-large uk-flex-left" data-uk-tab="{connect:'#team_tabbed',animation: 'slide-bottom'}">
        <li class="uk-active" aria-expanded="true"><a (click)="changeView('general')">General</a></li>
        <li aria-expanded="false"><a (click)="changeView('classification')">Classification</a></li>
        <li aria-expanded="false"><a (click)="changeView('availability')">Usage & Availability</a></li>
        <li aria-expanded="false"><a (click)="changeView('maturity')">Maturity</a></li>
        <li aria-expanded="false"><a (click)="changeView('funder')">Funder</a></li>
      </ul>

      <ul id="team_tabbed" class="uk-switcher dataContainer">

        <li aria-hidden="false" class="uk-active" style="animation-duration: 200ms;">

          <div class="uk-grid uk-grid-match uk-grid-row-medium uk-margin-small-top uk-child-width-1-1@m uk-child-width-1-1@l uk-child-width-1-1@s">

            <div class="uk-grid-margin">
              <div class="uk-card chartCard">
                <div class="uk-card-body">
                  @if (onboardingTimelineChartURL) {
                    <iframe width="100%" height="350" [src]="onboardingTimelineChartURL"></iframe>
                  }
                </div>
              </div>
            </div>

            <div class="uk-grid-margin">
              <div class="uk-card chartCard">
                <div class="uk-card-body">
                  @if (byProviderChartURL) {
                    <iframe width="100%" height="450" [src]="byProviderChartURL"></iframe>
                  }
                </div>
              </div>
            </div>

          </div>

        </li>

        <li aria-hidden="true" style="animation-duration: 200ms;">
          <div class="uk-grid uk-grid-match uk-grid-row-medium uk-margin-small-top uk-child-width-1-2@m uk-child-width-1-2@l uk-child-width-1-1@s">

            <div class="uk-grid-margin">
              <div class="uk-card chartCard">
                <div class="uk-card-body">
                  @if (byScientificDomainChartURL) {
                    <iframe width="100%" height="450" [src]="byScientificDomainChartURL"></iframe>
                  }
                </div>
              </div>
            </div>

            <div class="uk-grid-margin">
              <div class="uk-card chartCard">
                <div class="uk-card-body">
                  @if (byScientificSubdomainChartURL) {
                    <iframe width="100%" height="450" [src]="byScientificSubdomainChartURL"></iframe>
                  }
                </div>
              </div>
            </div>

            <div class="uk-grid-margin">
              <div class="uk-card chartCard">
                <div class="uk-card-body">
                  @if (byCategoryChartURL) {
                    <iframe width="100%" height="450" [src]="byCategoryChartURL"></iframe>
                  }
                </div>
              </div>
            </div>

            <div class="uk-grid-margin">
              <div class="uk-card chartCard">
                <div class="uk-card-body">
                  @if (bySubcategoryChartURL) {
                    <iframe width="100%" height="450" [src]="bySubcategoryChartURL"></iframe>
                  }
                </div>
              </div>
            </div>

          </div>
        </li>

        <li aria-hidden="true" style="animation-duration: 200ms;">

          <div class="uk-grid uk-grid-match uk-grid-row-medium uk-margin-small-top uk-child-width-1-3@m uk-child-width-1-3@l uk-child-width-1-1@s">

            <div class="uk-grid-margin">
              <div class="uk-card chartCard">
                <div class="uk-card-body">
                  @if (byAccessTypeChartURL) {
                    <iframe width="100%" height="450" [src]="byAccessTypeChartURL"></iframe>
                  }
                </div>
              </div>
            </div>

            <div class="uk-grid-margin">
              <div class="uk-card chartCard">
                <div class="uk-card-body">
                  @if (byAccessModeChartURL) {
                    <iframe width="100%" height="450" [src]="byAccessModeChartURL"></iframe>
                  }
                </div>
              </div>
            </div>

            <div class="uk-grid-margin">
              <div class="uk-card chartCard">
                <div class="uk-card-body">
                  @if (byOrderTypeChartURL) {
                    <iframe width="100%" height="450" [src]="byOrderTypeChartURL"></iframe>
                  }
                </div>
              </div>
            </div>

          </div>

          <div class="uk-grid uk-grid-match uk-grid-row-medium uk-margin-small-top uk-child-width-1-2@m uk-child-width-1-2@l uk-child-width-1-1@s">

            <div class="uk-grid-margin">
              <div class="uk-card chartCard">
                <div class="uk-card-body">
                  @if (byTargetUsersChartURL) {
                    <iframe width="100%" height="450" [src]="byTargetUsersChartURL"></iframe>
                  }
                </div>
              </div>
            </div>

            <div class="uk-grid-margin">
              <div class="uk-card chartCard">
                <div class="uk-card-body">
                  @if (byLanguageChartURL) {
                    <iframe width="100%" height="450" [src]="byLanguageChartURL"></iframe>
                  }
                </div>
              </div>
            </div>

          </div>

          <div class="uk-grid uk-grid-match uk-grid-row-medium uk-margin-small-top uk-child-width-1-1@m uk-child-width-1-1@l uk-child-width-1-1@s">

            <div class="uk-grid-margin">

              <!--                            <div *ngIf="!mapDistributionOfServicesOptions" class="uk-position-center uk-padding-large" style="z-index: 100">-->
              <!--                                <div uk-spinner="ratio: 3"></div>-->
            <!--                            </div>-->
            <div class="uk-width-1-1 uk-card">
              <div class="uk-card-body">
                @if (mapDistributionOfServicesOptions) {
                  <highcharts-chart [Highcharts]="Highcharts"
                    [options]="mapDistributionOfServicesOptions"
                    [constructorType]="chartConstructor"
                    style="width: 100%; height: auto; display: block;">
                    <!--                            <series (click)="onMapSeriesClick($event)">-->
                  <!--                            </series>-->
                </highcharts-chart>
              }
            </div>
          </div>

        </div>
      </div>

    </li>

    <li aria-hidden="true" style="animation-duration: 200ms;">
      <div class="uk-grid uk-grid-match uk-grid-row-medium uk-margin-small-top uk-child-width-1-2@m uk-child-width-1-2@l uk-child-width-1-1@s">

        <div class="uk-grid-margin">
          <div class="uk-card chartCard">
            <div class="uk-card-body">
              @if (byTRLChartURL) {
                <iframe width="100%" height="450" [src]="byTRLChartURL"></iframe>
              }
            </div>
          </div>
        </div>

        <div class="uk-grid-margin">
          <div class="uk-card chartCard">
            <div class="uk-card-body">
              @if (byLifecycleChartURL) {
                <iframe width="100%" height="450" [src]="byLifecycleChartURL"></iframe>
              }
            </div>
          </div>
        </div>

      </div>
    </li>

    <li aria-hidden="true" style="animation-duration: 200ms;">
      <div class="uk-grid uk-grid-match uk-grid-row-medium uk-margin-small-top uk-child-width-1-2@m uk-child-width-1-2@l uk-child-width-1-1@s">

        <div class="uk-grid-margin">
          <div class="uk-card chartCard">
            <div class="uk-card-body">
              @if (byFundingBodyChartURL) {
                <iframe width="100%" height="450" [src]="byFundingBodyChartURL"></iframe>
              }
            </div>
          </div>
        </div>

        <div class="uk-grid-margin">
          <div class="uk-card chartCard">
            <div class="uk-card-body">
              @if (byFundingProgramChartURL) {
                <iframe width="100%" height="450" [src]="byFundingProgramChartURL"></iframe>
              }
            </div>
          </div>
        </div>

      </div>
    </li>
  </ul>

</div>

</div>
</div>

<div id="servicesPerCountryModal" uk-modal>

  <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
    <h3>{{selectedCountryName}}</h3>

    <p>Services offered in country: </p>

    @for (service of selectedCountryServices; track service) {
      <div>
        <a (click)="visitSelectedServicePage(service.id)">{{service.name}}</a>
      </div>
    }
    <!--<ul>-->
    <!--<li *ngFor="let service of selectedCountryServices">-->
    <!--<a [routerLink]="['/service/' + service.id]">{{service.name}}</a>-->
  <!--</li>-->
<!--</ul>-->
</div>
</div>
